<template>
  <div class="inline-block text-left" v-click-outside="ocultar">
    <div>
      <button type="button" @click="show=!show"
              class="inline-flex justify-center w-full rounded-md border border-gray-300 shadow-sm px-4 py-0.5 bg-white font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 "
              id="options-menu" aria-expanded="true" aria-haspopup="true">
        {{ label }}
        <!-- Heroicon name: solid/chevron-down -->
        <svg class="transition-transform transform mr-1 ml-2 h-5 w-5"
             :class="show ? 'rotate-180':''"
             xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
             aria-hidden="true">
          <path fill-rule="evenodd"
                d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                clip-rule="evenodd"/>
        </svg>
      </button>
    </div>
    <div v-show="show"
         class="origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none z-10"
         role="menu" aria-orientation="vertical" aria-labelledby="options-menu">
      <div class="py-1" role="none" v-if="userProfile.primer_nombre">
        <router-link to="/perfil"
                     class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 cursor-pointer"
                     role="menuitem"
                     @click="editarPerfil()" v-slot="{navigate, href}">
          <span @click="editarPerfil(href)">Editar Perfil</span>
        </router-link>
      </div>
      <div class="py-1" role="none">
        <router-link to="/login"
                     class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 cursor-pointer"
                     role="menuitem"
                     @click="cerrarSession()" v-slot="{navigate, href}">
          <span @click="cerrarSession(href)">Cerrar Sesión</span>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import router from "../router";

export default {
  name: "dropdown",
  props: {
    label: {
      type: String,
      default: 'Options'
    },
    items: {
      type: Array,
    }
  },
  data: () => ({
    show: false
  }),
  methods: {
    ocultar() {
      this.show = false
    },
    cerrarSession(href) {
      localStorage.clear()
      this.setToken(null)
      this.setMenu([])
      router.push(href).catch(err => {
      })
    },
    editarPerfil(href) {
      router.push(href).catch(err => {
      })
    },
    ...mapActions({
      setToken: 'setToken',
      setUserInfo: 'setUserInfo',
      setMenu: 'utils/setMenu'
    }),
  },
  computed: {
    ...mapGetters({
      showSideBar: 'utils/getShowSideBar',
      userInfo: 'getUserInfo',
      userProfile: 'getPerfilUsuario'
    })
  }

}
</script>

<style scoped>

</style>
